import React from "react"
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Button,
    Divider,
    Stack,
} from "@mui/material"
import { useCreateTransferCertificateMutation } from "../Redux/actions/certificate.action"
import { updateFields, resetForm } from "../Redux/actions/formValue.action"
import { useSelector, useDispatch } from "react-redux"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite"
import _ from "lodash"

const TransferCertificateForm = () => {
    const dispatch = useDispatch()
    const [generateTransferCer, generateTransferCerState] = useCreateTransferCertificateMutation()

    const formValue = useSelector(state => state.form)
    const student_name = _.get(formValue, "state.student_name", "")
    const institution_name = _.get(formValue, "state.institution_name", "")
    const father_name = _.get(formValue, "state.father_name", "")
    const dob = _.get(formValue,"state.dob","")
    const class_studied = _.get(formValue,"state.class_studied","")
    const last_exam = _.get(formValue,"state.last_exam","")
    const reason = _.get(formValue,"state.reason","")
    const conduct = _.get(formValue,"state.conduct","")


    React.useEffect(() => {
        if (generateTransferCerState.isSuccess) {
            const blob = generateTransferCerState.data

            const url = window.URL.createObjectURL(blob)

            const a = document.createElement("a")
            a.href = url
            a.download = "Promotion_certificate.pdf"
            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(url)
            generateTransferCerState.reset()
            dispatch(resetForm())
        } else if (generateTransferCerState.isError) {
            toaster.push(<Message type="error" >Error while create the School Leaving certificate,Please try again later!</Message>, { placement: "topCenter" })
            generateTransferCerState.reset()
        }
    }, [generateTransferCerState.status])
    const handleSubmit = () => {
        if (
            !conduct || !student_name || !father_name || !institution_name || !dob || !class_studied || !last_exam || !reason
        ) {
            toaster.push(<Message type="info">Please fill all fields value!</Message>, { placement: "topCenter" })
            return
        }
        const data = {
            student_name:student_name,
            institution:institution_name,
            dob:dob,
            father_name:father_name,
            class_studied:class_studied,
            last_exam:last_exam,
            reason:reason,
            conduct:conduct
        }
        generateTransferCer(data)
    }

    return (
        <Box sx={{ maxWidth: 720, mx: "auto", mt: 5 }}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight={600}>
                        Transfer(TC)'s Certificate
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Enter student and school details carefully
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Stack spacing={2.5}>
                        <TextField
                            label="Student Name"
                            name="student_name"
                            fullWidth
                            placeholder="eg.Bhuban Padun"
                            value={student_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ student_name: val }))
                            }}
                        />
                        <TextField
                            label="Institution Name"
                            name="institution_name"
                            placeholder="eg. ABC Public School"
                            fullWidth
                            value={institution_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ institution_name: val }))
                            }}
                        />
                        <TextField
                            label="Father OR Mother Name"
                            name="father_name"
                            placeholder="eg. Rahul"
                            rows={2}
                            fullWidth
                            value={father_name}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ father_name: val }))
                            }}
                        />
                        <TextField
                            label="Enter DOB"
                            name="dob"
                            placeholder="eg. 23 April 1996"
                            rows={2}
                            fullWidth
                            value={dob}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ dob: val }))
                            }}
                        />
                        <TextField
                            label="Present Class Name"
                            name="class_studied"
                            placeholder="eg. Class - 10"
                            rows={2}
                            fullWidth
                            value={class_studied}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ class_studied: val }))
                            }}
                        />
                        <TextField
                            label="Last Examination"
                            name="last_exam"
                            placeholder="eg. Class - 10 Annual Examination"
                            rows={2}
                            fullWidth
                            value={last_exam}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ last_exam: val }))
                            }}
                        />
                        <TextField
                            label="TC Reason ?"
                            name="reason"
                            placeholder="eg. Parent Transfer"
                            rows={2}
                            fullWidth
                            value={reason}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ reason: val }))
                            }}
                        />
                        <TextField
                            label="Student Behaviour"
                            name="conduct"
                            placeholder="eg. Good"
                            rows={2}
                            fullWidth
                            value={conduct}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ conduct: val }))
                            }}
                        />
                        
                    </Stack>

                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ px: 4 }}
                            onClick={handleSubmit}
                        >
                            Generate Certificate
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            {
                (
                    generateTransferCerState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    );
};

export default TransferCertificateForm
